import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import LoanInterestModalUI from './LoanInterestModalUI'

class LoanInterestModalSF extends Component {
	constructor(props) {
		super(props)
		this.state = {
			successMsg: null,
			errorList: null,
			submitted: false,
			status: null,
			startDate: '',
			startDateError: null,
			endDate: '',
			endDateError: null
		}
	}

	render() {
		return (
			<LoanInterestModalUI
				context={this.props.context}
				errorList={this.state.errorList}
				successMsg={this.state.successMsg}
				setErrorList={this.setErrorList}
				// modes
				loanInterestMode={this.props.loanInterestMode}
				submitted={this.state.submitted}
				status={this.state.status}
				// event handlers
				onSubmit={this.onSubmit}
				onLoanInterestCancel={this.props.onLoanInterestCancel}
				// form fields
				startDate={this.state.startDate}
				onStartDateChange={(startDate) => { this.setState({ startDate: startDate }) }}
				startDateError={this.state.startDateError}
				setStartDateError={(error) => { this.setState({ startDateError: error }) }}
				//
				endDate={this.state.endDate}
				onEndDateChange={(endDate) => { this.setState({ endDate: endDate }) }}
				endDateError={this.state.endDateError}
				setEndDateError={(error) => { this.setState({ endDateError: error }) }}
			/>
		)
	}

	componentDidMount() {
		Modal.setAppElement('body')
	}

	onSubmit = (event) => {
		event.preventDefault();
		if (this.state.submitted) return;

		const { context, loan } = this.props;

		this.setState({
			successMsg: null,
			errorList: [],
			submitted: true
		});

		RestApiUtils.get(
			context,
			`/api/su/loans/${loan.loanId}/certificateOfInterest/fileDownloadSignedUrl`,
			this.onSubmitCallback, null,
			{
				startDateISO: this.state.startDate,
				endDateISO: this.state.endDate,
			}
		);
	}


	onSubmitCallback = (response) => {
		let errorList = [];
		if (response.errorList) {
			response.errorList.forEach(error => {
				errorList.push(error.message);
			});
		}

		this.setState({
			successMsg: response.success,
			errorList: errorList,
			submitted: false
		});

		if (response.errorList && response.errorList.length === 0) {
			if (response.signedUrl && response.signedUrl.signedUrl) {
				const link = document.createElement('a');
				link.href = response.signedUrl.signedUrl;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
			this.props.onLoanInterestCancel();
		}
	}



	setErrorList = (errorList) => {
		this.setState({ errorList: errorList })
	}
}

export default LoanInterestModalSF
